import { useMutation, useQueryClient } from '@tanstack/react-query';
import { referralApi } from '../api/referral.api';
import { referralKeys } from '../api/referral.keys';
import toast from 'react-hot-toast';

export function useCreateReferral() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => referralApi.create(data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: referralKeys.all }); toast.success('Referral created'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to create'); },
  });
}

export function useUpdateReferral() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => referralApi.update(id, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: referralKeys.all }); toast.success('Referral updated'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to update'); },
  });
}

export function useDeleteReferral() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => referralApi.delete(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: referralKeys.all }); toast.success('Referral deleted'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to delete'); },
  });
}
